import { mapGetters } from 'vuex';
import Forms from '../../utils/forms/forms';
import store from './../../store';
import contactTypeservice from '../../services/contactType';
import VFormTable from './../../components/clientContactFormTable/clientContactFormTable.vue';
import stringFormatMixin from './../../mixins/stringFormat';

export default {
  props: {
    primaryContactError: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      form: new Forms({
        id: {
          value: null,
          type: 'plaintext',
        },
        contactId: {
          value: null,
          type: 'plaintext',
        },
        type: {
          value: null,
          type: 'plaintext',
        },
        contactType: {
          value: [],
          type: 'select',
        },
        firstName: {
          value: '',
          type: 'text',
        },
        lastName: {
          value: '',
          type: 'text',
        },
        email: {
          value: '',
          type: 'text',
        },
        phoneNumber: {
          value: '',
          type: 'text',
        },
      }),
    };
  },
  created() {
    this.loading = true;
    this.form.setTooltip('mobileNumber', this.$t('form.clients.mobileNumber.tooltip'));
    Promise.all([
      contactTypeservice.all(),
    ]).then(() => {
      this.loading = false;
      this.form.setExtraAttr('contactType', {
        filterable: true,
        multiple: true,
      });
    });
  },
  computed: {
    ...mapGetters({
      currentClientContacts: 'currentClientContacts',
      contactTypes: 'contactTypes',
    }),
    hiddenFields() {
      return ['id', 'contactId', 'type'];
    },
  },
  watch: {
    /**
     * Watches state update to inject on Forms class.
     *
     * @param  {Object} contactTypes The client contact types list.
     */
    /* eslint max-len: ["error", 150] */
    contactTypes(contactTypes) {
      const contactTypeOptions = contactTypes.map(item => ({
        id: item.id,
        name: this.$t(`form.contactTypes.options.${this.camelize(item.name)}`),
      }));
      this.form.setOptions('contactType', contactTypeOptions);
    },
  },
  methods: {
    /**
     * Saves the form, adding a client contact
     */
    save() {
      const data = this.form.data();
      data.id = data.contactType.join();
      const hasDuplicate = this.currentClientContacts.find(x => x.id === data.id);
      if (!hasDuplicate) {
        store.dispatch('addClientContact', data);
      } else {
        this.$message({
          showClose: true,
          customClass: 'error',
          message: 'Contact type duplicate found',
        });
        return Promise.reject();
      }

      return Promise.all([]);
    },

    /**
     * Updates a client contact
     */
    update(id) {
      const data = this.form.data();
      const i = this.currentClientContacts.findIndex(x => x.id === id);
      store.dispatch('updateClientContact', {
        data,
        i,
      });
      return Promise.all([]);
    },
      /**
       * Delete the client contact.
       */
    destroy(index, item) {
      const id = item.contactType.join();
      const i = this.currentClientContacts.findIndex(x => x.id === id);
      store.dispatch('deleteClientContact', i);
      return Promise.all([]);
    },
    camelize(str) {
      return str.toLowerCase().replace(/[^a-zA-Z0-9]+(.)/g, (m, chr) => chr.toUpperCase());
    },
  },

  components: {
    VFormTable,
  },

  mixins: [
    stringFormatMixin,
  ],
};



// WEBPACK FOOTER //
// ./src/app/components/clientContact/clientContact.js